import { toast } from 'react-hot-toast';

let activeToastId = null;

const showToast = (type, message, options = {}) => {
  // If a toast is already shown, dismiss it
  if (activeToastId) {
    toast.dismiss(activeToastId);
  }

  // Show the new toast and store its ID
  activeToastId = toast[type](message, {
    ...options,
    id: message, // Helps avoid duplicates
    onClose: () => {
      // Reset ID only if it's the one we closed
      if (activeToastId === message) {
        activeToastId = null;
      }
    },
  });

  return activeToastId;
};

export const toastService = {
  success: (msg, options) => showToast('success', msg, options),
  error: (msg, options) => showToast('error', msg, options),
  warning: (msg, options) => showToast('warning', msg, options),
  info: (msg, options) => showToast('custom', msg, options),
};
